const MiffView = () =>
  // @ts-ignore
  import(/*webpackChunkName: "MiffView"*/ "@/views/sales/MiffView.vue");

export default {
  path: "miff",
  name: "miff",
  alias: [],
  component: MiffView,
  meta: {
    requiresAuth: false,
    requiresEntitlement: false,
  },
};
